<template>
   <div>
     <Loading v-if="getIsLoading"/>
     <header>
        <p>{{getTranslation.create_review}}</p>
    </header>

    <router-view v-if="init" class="components" :user="getUser" :lang="getTranslation"/>

   </div>
</template>



<script>

/**
 * @TEST
 * - 홈: http://localhost:8081/?t=site&k=dMSn2t
 * - 성공: http://localhost:8081/?t=site&k=dMSn2t#/finish
 * - 실패: http://localhost:8081/?t=site&k=ddddMSn2t#/err
 */
import Loading from '@/components/items/Loading'
import {mapGetters} from 'vuex'
export default {
  name: 'App',
  components: {
    Loading
  },
  async created(){
    await this.$store.dispatch('fetchCustomItem', { key: this.getUser.k });
    this.init=true;
  },
  data(){
    return {
      init: false
    }
  },
  computed:{
    ...mapGetters(['getUser', 'getTranslation', 'getIsLoading'])
  },
  methods: {
    close(){
       Window.close();
    }
  }
}
</script>

<style lang="scss" scoped>
header {
    box-shadow: 0px 3px 8px #3d3d3d24;
    height: 40px;
    padding: 0 16px;
    @include positions(fixed, 0, 0, unset, 0);
    @include flexs-align(center, unset);
    background-color: #FFFFFF;
    z-index: 99;

    p {
        color: #898989;
        flex: 1;
    }


}

.components {
  
  @include positions(fixed, 40px, 0, 0, 0);
  overflow: auto;
}
</style>